import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Clock, DollarSign, PenTool, Users, HeadphonesIcon } from 'lucide-react';
const reasons = [{
  icon: <MessageCircle size={24} data-id="element-347" data-mp="qfmlbu8ydovt" />,
  title: 'Direct Access to Owner',
  desc: 'No middle-men. You speak directly with me for all decisions and updates.'
}, {
  icon: <Clock size={24} data-id="element-348" data-mp="106h8d0u0wsib" />,
  title: 'Fast Response Times',
  desc: 'I prioritize communication. Expect quick replies and rapid project turnarounds.'
}, {
  icon: <DollarSign size={24} data-id="element-349" data-mp="7j3l5ug4nbbe" />,
  title: 'Affordable Pricing',
  desc: 'Agency-quality work without the massive agency overhead costs.'
}, {
  icon: <PenTool size={24} data-id="element-350" data-mp="chet1zmv3bqz" />,
  title: 'Custom-Built Websites',
  desc: 'Tailored specifically for your business goals.'
}, {
  icon: <Users size={24} data-id="element-351" data-mp="gl4gglrsvnaf" />,
  title: 'No Outsourced Work',
  desc: 'Quality control is 100% guaranteed.'
}, {
  icon: <HeadphonesIcon size={24} data-id="element-352" data-mp="1nzfyr6dp6p5w" />,
  title: 'Ongoing Support',
  desc: "I don't disappear after launch. I'm here for minor updates, hosting, and maintenance."
}];
export function WhyChooseMe() {
  return <section className="py-24 bg-[#0A0A0F] relative overflow-hidden" data-id="element-353" data-mp="1o1xlgc817c8o">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-354" data-mp="1j2ul352zxu71"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-355" data-mp="1a3pk7s3yporp">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-356" data-mp="155fnhd2lag3z">
          <div className="lg:w-1/3" data-id="element-357" data-mp="10efswegy0a4n">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-358" data-mp="10dedjxsw91h4">
              Why Choose <br data-id="element-359" data-mp="mdd3psunijpi" />
              <span className="text-gradient" data-id="element-360" data-mp="mdv7rbnk227z">Mike's Pro Web Design</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg mb-8 text-[#FFFFFF]" data-id="element-361" data-mp="hgd8kczcb1d6">
              Hiring a massive agency means paying for their office space and
              managers. Hiring me means paying for pure expertise and results.
            </motion.p>
            <motion.a initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} href="#contact" className="inline-flex items-center justify-center px-8 py-4 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium transition-all" data-id="element-362" data-mp="qjidq5f976fy">
              Let's Talk About Your Project
            </motion.a>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-363" data-mp="1e9mcnzhhyi0m">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex gap-4 p-6 rounded-2xl bg-[#111118] border border-white/5 hover:bg-[#161622] hover:border-blue-500/30 transition-all" data-id="element-364" data-mp="2ywm5ha4b875m" data-mpi={index}>
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-400" data-id="element-365" data-mp="2b0rk9p4341xt">
                  {reason.icon}
                </div>
                <div data-id="element-366" data-mp="2k1656nd4zf0s">
                  <h4 className="text-white font-bold mb-2" data-id="element-367" data-mp="2k0wpbslt2o8t">{reason.title}</h4>
                  <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-368" data-mp="49s0km6n45qu">
                    {reason.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}